import React, { useEffect, useState } from "react";
import Multiselect from "multiselect-react-dropdown";
import OptionsOutsideSelect from "./OptionsOutsideSelect";

export default function ProfileDetailsTab({
  setActiveTab,
  data,
  setData,
  projCategory,
  skills,
  setSkills,
  languages,
  spacialLanguages,
}) {
  // const [prevSkill, setPrevSkill] = useState('')
  const [startDateSelected, setStartDateSelected] = useState(false);
  const [profileTypeSelected, setProfileTypeSelected] = useState(false);
  const [selectedValues, setSelectedValues] = useState([]);
  const [skillValue, setSkillValue] = useState("");
  const [startDateClassName, setStartDateClassName] = useState("");
  const [profileTypeClassName, setProfileTypeClassName] = useState("");
  const [allLanguages, setAllLanguages] = useState([]);
  const [showInvalidDate, setShowInvalidDate] = useState(false);
  const [showInvalidProfileType, setShowInvalidProfileType] = useState(false);
  const [DoesNotExist, setDoesNotExist] = useState(false);
  const [suggestedSkills, setSuggestedSkills] = useState([
    "Generalist Consultant",
    "Project Management",
    "Agile Methods",
    "Process Optimization",
  ]);
  const [seniority, setSeniority] = useState([
    { name: "Junior (less than 5 years)", id: 1 },
    { name: "Mid-level (5-14 years)", id: 2 },
    { name: "Senior (15+ years)", id: 3 },
  ]);

  useEffect(() => {
    setAllLanguages([...spacialLanguages, ...languages]);
  }, [languages, spacialLanguages]);

  const checkboxHandler = (e) => {
    if (e.target.checked) {
      setData({
        ...data,
        projectSuggestedSkills: [...data.projectSuggestedSkills, e.target.id],
      });
    } else {
      setData({
        ...data,
        projectSuggestedSkills: data.projectSuggestedSkills.filter(
          (skill) => skill !== e.target.id
        ),
      });
    }
  };

  const handleSelectChange = (values) => {
    setSkillValue(values);
    setData({ ...data, projectSkillsRequirements: values });
  };

  return (
    <fieldset>
      <div className="form-card">
        <div className="flex-center mb-1">
          <label className="fieldlabels">Profile Type</label>
          <div className="w-100">
            <select
              className={`form-control ${profileTypeClassName}`}
              onChange={(e) => {
                if (e.target.value) {
                  setData({ ...data, projectConsultantType: e.target.value });
                  setProfileTypeSelected(true);
                  setProfileTypeClassName("");
                  setShowInvalidProfileType(false);
                } else {
                  setProfileTypeSelected(false);
                  setProfileTypeClassName("");
                }
              }}
              value={data.projectConsultantType}
            >
              <option value="">Select profile type</option>
              <option value="con">
                Consultants (Long-term project support)
              </option>
              <option value="exp">Experts (Expert call)</option>
            </select>
            {showInvalidProfileType && (
              <span className="invalid-text-sign-profileType">
                Profile type required
              </span>
            )}
          </div>
        </div>
        <div className="flex-center mb-1">
          <label className="fieldlabels">Seniority</label>
          <div className="w-100">
            <Multiselect
              options={seniority}
              displayValue="name"
              placeholder="Select seniority"
              closeIcon="cancel"
              onSelect={(selectedList, selectedItem) => {
                setData({ ...data, projectSeniority: selectedList });
              }}
              onRemove={(selectedList, removedItem) => {
                setData({ ...data, projectSeniority: selectedList });
              }}
              style={{
                chips: {
                  background: "#365561",
                },
                searchBox: {
                  border: "none",
                  width: "100%",
                },
                multiselectContainer: {
                  width: "100%",
                },
                optionContainer: {
                  marginTop: "-21px",
                },
              }}
            />
          </div>
        </div>
        <div className="flex-center mb-1">
          <label className="fieldlabels" style={{ paddingTop: "3px" }}>
            Suggested Skills
          </label>
          <div className="w-100">
            <div style={{ display: "flex", flexWrap: "wrap" }}>
              {data.projectCategory ? (
                <>
                  {suggestedSkills.map((skill) => (
                    <div className="prjsetup-skill-checkbox">
                      <input
                        type="checkbox"
                        id={skill}
                        onChange={checkboxHandler}
                      />
                      <label htmlFor={skill}>{skill}</label>
                    </div>
                  ))}
                  {projCategory &&
                    Object.keys(projCategory).map((category) => {
                      if (category === data.projectCategory) {
                        return projCategory[category]["skills"].map((skill) => (
                          <div className="prjsetup-skill-checkbox">
                            <input
                              type="checkbox"
                              id={skill}
                              onChange={checkboxHandler}
                            />
                            <label htmlFor={skill}>{skill}</label>
                          </div>
                        ));
                      } else return null;
                    })}
                </>
              ) : (
                <>
                  {suggestedSkills.map((skill) => (
                    <div className="prjsetup-skill-checkbox">
                      <input
                        type="checkbox"
                        id={skill}
                        onChange={checkboxHandler}
                      />
                      <label htmlFor={skill}>{skill}</label>
                    </div>
                  ))}
                </>
              )}
            </div>
          </div>
        </div>
        <div className="flex-center mb-1">
          <label className="fieldlabels">Other Skills</label>
          <div className="w-100">
            <OptionsOutsideSelect
              isMulti
              onChange={handleSelectChange}
              options={skills}
              value={skillValue}
            />
          </div>
        </div>
        <div className="flex-center mb-1">
          <label className="fieldlabels">Language</label>
          <div className="w-100">
            <Multiselect
              options={allLanguages}
              displayValue="name"
              placeholder="Select language"
              closeIcon="cancel"
              groupBy={"type"}
              onSelect={(selectedList, selectedItem) => {
                setData({ ...data, projectLanguages: selectedList });
              }}
              onRemove={(selectedList, removedItem) => {
                setData({ ...data, projectLanguages: selectedList });
              }}
              style={{
                chips: {
                  background: "#365561",
                },
                searchBox: {
                  border: "none",
                  width: "100%",
                },
                multiselectContainer: {
                  width: "100%",
                },
                optionContainer: {
                  marginTop: "-21px",
                },
              }}
            />
          </div>
        </div>

        {/* <div className='flex-center mb-1 position-relative'>
                <label className="fieldlabels">Project Start Date*</label>
                <select className={`form-control ${startDateClassName}`} style={{marginTop:'2px',}} onChange={(e) => {
                    setData({...data, projectStartDate: e.target.value, projectStartDateOption: e.target.value})
                    if (e.target.value && e.target.value !== 'Specific start date') {
                        setStartDateSelected(true)
                        setStartDateClassName('')
                        setShowInvalidDate(false)
                    } else {
                        setStartDateSelected(false)
                        setStartDateClassName('')
                    }
                }} value={data.projectStartDateOption}>
                    <option value="">Select start date</option>
                    <option value="In the next 2 weeks">In the next 2 weeks</option>
                    <option value="In the next month">In the next month</option>
                    <option value="In the next 3 months">In the next 3 months</option>
                    <option value="Specific start date">Choose specific start date</option>
                </select>
                {data.projectStartDateOption === 'Specific start date' && (
                    <input className={`form-control ml-3 ${startDateClassName}`} type="date" 
                        onChange={(e) => {
                            setData({...data, projectStartDate: e.target.value})
                            if (e.target.value){
                                setStartDateSelected(true)
                                setStartDateClassName('')
                                setShowInvalidDate(false)
                            } else {
                                setStartDateSelected(false)
                                setStartDateClassName('')
                                setShowInvalidDate(true)
                            }
                        }}
                        value={data.projectStartDate}
                    />
                )}
                {showInvalidDate && <span className='invalid-text-sign'>Start date required</span>}
            </div>
            <div className='flex-center mb-1'>
                <label className="fieldlabels">Project Duration</label>
                <select className='form-control'  onChange={(e) => setData({...data, projectDuration: e.target.value})} value={data.projectDuration}>
                    <option value="">Select project duration</option>
                    <option value="Expert Call">Expert Call</option>
                    <option value="Less than one month">Less than one month</option>
                    <option value="1-3 months">1-3 months</option>
                    <option value="4-6 months">4-6 months</option>
                    <option value="More than 6 months">More than 6 months</option>
                </select>
            </div>
            <div className='flex-center mb-1'>
                <label className="fieldlabels">Type of Employment</label>
                <select className='form-control' onChange={(e) => setData({...data, projectTypeOfEmployment: e.target.value})} value={data.projectTypeOfEmployment}>
                    <option value="">Select type of employment</option>
                    <option value="Onsite">Onsite</option>
                    <option value="Remote">Remote</option>
                    <option value="Hybrid">Hybrid</option>
                </select>
                {data.projectTypeOfEmployment === 'Hybrid' && (
                    <>
                        <input type="text" placeholder="Remote %" className='ml-3'
                            onChange={(e) => setData({...data, projectRemoteOption: e.target.value})}
                            value={data.projectRemoteOption}
                        />
                        <input type="text" placeholder="Onsite %" className='ml-3'
                            onChange={(e) => setData({...data, projectOnsiteOption: e.target.value})}
                            value={data.projectOnsiteOption}
                        />
                    </>
                )}
            </div> */}
      </div>
      <input
        onClick={() => {
          if (profileTypeSelected) {
            setActiveTab("finish");
          } else if (!profileTypeSelected) {
            setProfileTypeClassName("border border-danger");
            setShowInvalidProfileType(true);
          } else {
            setProfileTypeClassName("border border-danger");
            setShowInvalidProfileType(true);
          }
        }}
        type="button"
        className="action-button"
        defaultValue="Next"
      />
      <input
        onClick={() => setActiveTab("projectDetails")}
        type="button"
        className="action-button-previous"
        defaultValue="Previous"
      />
    </fieldset>
  );
}
